<template>
  <div id="skybanner">
    <div class="inr">
      <!-- 배너 영역: 닫기 버튼 -->
      <div  v-show="bannerVisible" class="ban_area">
        <RouterLink :to="{ name: 'ContentsView', params: { contsId: '00011' } }" class="ban03"><p>기존회원 <br> 비밀번호 <br> 변경안내</p></RouterLink>
        <a href="#" class="ban01" @click.prevent="navigateToMyRsvt"><p>내 예약확인 <br> <span>(이전 예약포함)</span></p></a>
        <!-- <button type="button" class="btn_close" @click="closeBanner">닫기</button>-->
      </div>

      <!-- 줌 컨트롤 (zoom %) -->
      <div class="zoom_area">
        <span class="zoom_tit">글자크기</span>
        <!--<span class="zoom_num" aria-live="polite">{{ zoomPct }}%</span>-->
        <div class="zoom_inout">
          <button type="button" class="btn_zin" @click="setZoom(1)">
            <span class="hidden">글자크기 확대</span>
          </button>
          <button type="button" class="btn_zout" @click="setZoom(-1)">
            <span class="hidden">글자크기 축소</span>
          </button>
        </div>
        <div class="zoom_reset">
          <button type="button" class="btn_reset" @click="resetZoom">원본보기</button>
        </div>
      </div>

      <!-- 상단 이동 -->
      <a href="#header" class="goto_top" @click.prevent="gotoTop">
        <span class="hidden">페이지 상단으로 이동</span>
      </a>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import { useRouter } from "vue-router";
import { getUserInfo } from "@/service/common.service";
import { useAlert } from '@/composables/useAlert'
const { showAlert } = useAlert()

defineOptions({name: "FloatingMenu"});

const router = useRouter();

const bannerVisible = ref(true);

// zoom 상태 (%)
const zoomPct = ref(100);
const STEP = 10;
const MIN_ZOOM = 50;
const MAX_ZOOM = 200;

onMounted(() => {
  // body.style.zoom이 비어있으면 100%로 간주
  const z = document.body.style.zoom;
  zoomPct.value = z && z.endsWith("%") ? parseInt(z, 10) || 100 : 100;
  applyZoom();
});

function applyZoom() {
  document.body.style.zoom = `${zoomPct.value}%`;
  // jQuery 버전은 .a11y_nav .zoom_num 텍스트를 갱신했지만,
  // 여기선 템플릿에서 {{ zoomPct }}%로 표시하므로 추가 DOM 조작 불필요.
}

function setZoom(dir /* 1 = 확대, -1 = 축소 */) {
  const next = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, zoomPct.value + STEP * (dir > 0 ? 1 : -1)));
  zoomPct.value = next;
  applyZoom();
}

function resetZoom() {
  zoomPct.value = 100;
  applyZoom();
}

function closeBanner() {
  bannerVisible.value = false;
}

// 내 예약확인 로그인 체크
const navigateToMyRsvt = async () => {
  try {
    const res = await getUserInfo()

    if (!res?.result) {
      await showAlert('로그인 한 후에 이용 가능합니다. 로그인 화면으로 이동합니다.')
      router.push({ name: 'Login' })
      return
    }
    
    // 로그인되어 있으면 이동
    router.push({ name: 'MyRsvtList' })
  } catch (error) {
    await showAlert(error?.serverMessage || '로그인 한 후에 이용 가능합니다. 로그인 화면으로 이동합니다.')
    router.push({ name: 'Login' })
  }
}

function gotoTop() {
  const header = document.querySelector("#header");
  const y = header ? header.getBoundingClientRect().top + window.pageYOffset : 0;
  window.scrollTo({top: y, behavior: "smooth"});
}
</script>
